import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-260dfd78"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "OAvatarProfissional",
  "data-testid": "OAvatarProfissional"
}
const _hoisted_2 = { class: "OAvatarProfissional__Infos" }

import { usarFuncoesStrings } from "@/composable/UsarFuncoesStrings/usarFuncoesStrings"
  import Avatar from "primevue/avatar"

  interface Props {
    nomeProfissional: string
    emailProfissional?: string
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OAvatarProfissional',
  props: {
    nomeProfissional: null,
    emailProfissional: null
  },
  setup(__props: any) {

  

  const { pegarIniciais } = usarFuncoesStrings()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Avatar), {
      class: "OAvatarProfissional__Foto",
      label: _unref(pegarIniciais)(__props.nomeProfissional),
      shape: "circle",
      size: "large",
      style: { 'background-color': '#00707d', color: 'white' }
    }, null, 8, ["label"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(__props.nomeProfissional), 1),
      _createElementVNode("small", null, _toDisplayString(__props.emailProfissional), 1)
    ])
  ]))
}
}

})